// https://stackoverflow.com/a/13924997/3670829
export var textMaxLines = function (maxLines, lineHeight, adjustment) {
    if (adjustment === void 0) { adjustment = 0; }
    return "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: " + maxLines + ";\n  line-height: " + lineHeight + "px;\n  max-height: " + (lineHeight * maxLines + adjustment) + "px;\n  margin: 0;\n";
};
// https://css-tricks.com/snippets/css/remove-gray-highlight-when-tapping-links-in-mobile-safari/
export var highlightStyle = "\n  cursor: pointer;\n  -webkit-tap-highlight-color: rgba(0,0,0,0.05);\n";
